var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15909 11.1591L1.0483 6.0483C0.640625 5.64062 0.368845 5.16667 0.232955 4.62642C0.100379 4.08617 0.102036 3.54924 0.237926 3.01562C0.373816 2.47869 0.643939 2.01136 1.0483 1.61364C1.46259 1.20597 1.9349 0.935842 2.4652 0.803267C2.99882 0.667377 3.53078 0.667377 4.06108 0.803267C4.5947 0.939157 5.06866 1.20928 5.48295 1.61364L6.15909 2.26989L6.83523 1.61364C7.25284 1.20928 7.7268 0.939157 8.2571 0.803267C8.78741 0.667377 9.31771 0.667377 9.84801 0.803267C10.3816 0.935842 10.8556 1.20597 11.2699 1.61364C11.6742 2.01136 11.9444 2.47869 12.0803 3.01562C12.2161 3.54924 12.2161 4.08617 12.0803 4.62642C11.9477 5.16667 11.6776 5.64062 11.2699 6.0483L6.15909 11.1591Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.f87b2c9c4f1d6a1a08e304144e0091c7.svg";
export { ForwardRef as ReactComponent };